import { useState } from 'react';
import { cn } from '@rocco/utils/cn';
import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import { RICH_TEXT_CLASS } from '~/utils/rich-text';
import Specifications from '../product-details/Specifications';
import type Product from '../../type/product';

interface DescriptionProps {
    product: Product;
}

const Description = ({ product }: DescriptionProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const clickProxy = useWebsiteTrackingProxy(
        {
            professionalID: product.Professional.ID,
            professionalTitle: product.Professional.Title,
            itemType: 'Product',
            link: product.Professional.Link,
        },
        {
            attachUTM: true,
            processRelativeURL: true,
        }
    );

    return (
        <div
            className="pb-15 pt-10 text-base leading-normal md:pb-0 md:pt-0"
            onClick={clickProxy}
            onContextMenu={clickProxy}
        >
            <div
                className={cn(
                    'relative md:line-clamp-none md:max-h-none after:md:hidden',
                    !isExpanded &&
                        'line-clamp-3 max-h-16 after:pointer-events-none after:absolute after:inset-0 after:bg-gradient-to-b after:from-transparent after:to-white/50'
                )}
            >
                <div
                    className={cn(
                        'text-sm leading-[1.3] text-gray-800 md:text-base md:leading-normal',
                        RICH_TEXT_CLASS
                    )}
                    dangerouslySetInnerHTML={{
                        __html: product.Content ?? '',
                    }}
                />
                <Specifications data={product} />
            </div>
            <div className="mt-10 md:hidden">
                <button
                    className="py-1 text-sm font-medium leading-[1.3] text-gray-800 underline"
                    onClick={() => setIsExpanded((state) => !state)}
                >
                    {isExpanded ? 'View less' : 'View more'}
                </button>
            </div>
        </div>
    );
};

export default Description;
